var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-tags-input',{attrs:{"placeholder":'ajouter',"tags":_vm.data,"allow-edit-tags":true},on:{"tags-changed":(newTags) => (_vm.data = newTags)},model:{value:(_vm.word),callback:function ($$v) {_vm.word=$$v},expression:"word"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }